export class ConfiguracoesBike {
    tipo: string
    dataAquisicao: string
    anoFabricacao: number
    uso: Array<string>
    marca: string
    modelo: string
    numeroSerie: string
    localCompra: string
    valorMercado: number
    estadoConservacao: string
    notaFiscal: string
    material: string
    configuracao: string
    modalidade: Array<string>
    terreno: Array<string>
    frequenciaUso: string
    assist24hs: string
    isDanos: number
    isRoubo: number
    responsabilidadeCivil: number
    isDanosEletricos: number
    isApIndividual: number
    assessoriaEsportiva: string

    constructor() {
        this.tipo = null
        this.dataAquisicao = null
        this.anoFabricacao = null
        this.uso = null
        this.marca = null
        this.modelo = null
        this.numeroSerie = null
        this.localCompra = null
        this.valorMercado = null
        this.estadoConservacao = null
        this.notaFiscal = null
        this.material = null
        this.configuracao = null
        this.modalidade = null
        this.terreno = null
        this.frequenciaUso = null
        this.assist24hs = null
        this.isDanos = null
        this.isRoubo = null
        this.responsabilidadeCivil = null
        this.isDanosEletricos = null
        this.isApIndividual = null
        this.assessoriaEsportiva = null
    }
}